import { useEffect, useState } from "react";
import { formatRelativeTime } from "../utils/formatRelativeTime";

/*
	Возвращает относительное время от iso и обновляет его раз в минуту,
	чтобы метка «щойно / N хв / N год» не устаревала без перерендера.
*/
export const useRelativeTime = (iso: string | null | undefined): string => {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		const id = window.setInterval(() => setNow(Date.now()), 60_000);
		return () => window.clearInterval(id);
	}, []);

	if (!iso) return "";
	return formatRelativeTime(iso, now);
};
